import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/services/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("tgs-token");
    if (!token) {
      setLoading(false);
      return;
    }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem("tgs-token"); setUser(null); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data?.otp_required) return data;
    localStorage.setItem("tgs-token", data.token);
    setUser(data.user);
    return data.user;
  };

  const completeOtpLogin = async (challenge, code) => {
    const { data } = await api.post("/auth/login/otp", { challenge, code });
    localStorage.setItem("tgs-token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) { /* ignore */ }
    localStorage.removeItem("tgs-token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, completeOtpLogin, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
